import type { CSSProperties } from 'react';
import { useAppSelector } from 'redux/hooks';
import { tabSelector } from 'redux/selectors/queryParams';
import { TAB_PR } from '@doda/common/src/constants/properties/const';
import { appQueryParamsSelector } from '@doda/common/src/redux/features/queryParams';
import { Tab } from '../../types/tab';

/**
 * RouteTagのProps
 */
interface Props {
  initialTab: Tab;
  isScout: boolean;
}

/**
 * 経路別のタグ
 */
export const RouteTag: React.FC<Props> = ({ initialTab, isScout }) => {
  const tab = useAppSelector(tabSelector) ?? initialTab;
  const appQueryParams = useAppSelector(appQueryParamsSelector);
  const { entry_route, ndrs } = appQueryParams;

  const style: CSSProperties = {
    width: '0',
    height: '0',
    position: 'absolute',
  };

  // 以下を満たす場合は表示しない
  // ・PickUpタブである
  // ・スカウト原稿以外である
  if (tab === TAB_PR && !isScout) return null;
  return (
    <>
      {entry_route === '11' && (
        // クリテオ経由で遷移した場合のアドエビス埋め込み
        <img
          src="https://secure2.ebis.ne.jp/tr_set.php?argument=MC76WbSa&ai=a50da9463cc0fb"
          alt=""
          style={style}
        />
      )}
      {entry_route === '13' && (
        // indeed経由で遷移した場合のアドエビス埋め込み
        <img
          src="https://secure2.ebis.ne.jp/tr_set.php?argument=MC76WbSa&ai=a515cde60849b1"
          alt=""
          style={style}
        />
      )}
      {entry_route === '14' && (
        // メルマガ経由で遷移した場合のアドエビス埋め込み
        <img
          src="https://secure2.ebis.ne.jp/tr_set.php?argument=MC76WbSa&ai=a5164080d185f9"
          alt=""
          style={style}
        />
      )}
      {Boolean(ndrs) && (
        // お知らせ配信経由で遷移した場合のパラメータ情報を埋め込み
        <img
          src={`https://secure2.ebis.ne.jp/tr_set.php?argument=MC76WbSa&ai=${ndrs}`}
          alt=""
          style={style}
        />
      )}
    </>
  );
};
